import type { AppRoute } from "../app-routes.js";

const OFFER_CREATE_KINDS = new Set([
  "bundle-merge",
  "component-discount",
  "fixed-price-bundle",
  "free-gift",
  "volume-tiers",
]);

export function loadingPageState(
  route: AppRoute,
  search: string,
): {
  focusedOffer: boolean;
  heading: string;
  showOfferGallery: boolean;
} {
  const focusedOffer =
    route === "/offers" && OFFER_CREATE_KINDS.has(new URLSearchParams(search).get("create") ?? "");
  const heading =
    route === "/"
      ? "Stackproof Bundles"
      : route === "/online-store"
        ? "Online store"
        : route.slice(1).replace(/^./, (character) => character.toUpperCase());
  return { focusedOffer, heading, showOfferGallery: route === "/offers" && !focusedOffer };
}
